module.exports = __webpack_public_path__ + "static/anorlu-503b07218ec96d957dda772393d8e0fc.png";